import { Client, default as CustomAxios } from "../../axios";

export const getProfileData = async (userId) => {
  const res = await Client.get(`user/profile?user=${userId}&fields=all`);
  return res.data.data;
};
